import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './_guards/auth.guard';
import { BuyingGuideComponent } from './pages/buying-guide/buying-guide/buying-guide.component';
import { NoPageFoundComponent } from './pages/noPageFound/noPageFound.component';
import { CityUpdateComponent } from './pages/city-update/city-update.component';
// import { UserGuideComponent } from './pages/user-guide/user-guide.component';

const routes: Routes = [
  { path: '', loadChildren: () => import('./starter/home/home.module').then(m => m.HomeModule) },
  { path: 'page-not-found', loadChildren: () => import('./pages/noPageFound/pagenotfound.module').then((m) => m.PageNotFoundModule)},
  { path: 'about-us', loadChildren: () => import('./pages/about-us/about-us.module').then(m => m.AboutUsModule) },
  { path: 'contact-us', loadChildren: () => import('./pages/contact-us/contact-us.module').then(m => m.ContactUsModule) },
  { path: 'faq', loadChildren: () => import('./pages/faq/faq.module').then(m => m.FaqModule) },
  { path: 'disclaimer', loadChildren: () => import('./pages/disclaimer/disclaimer.module').then(m => m.DisclaimerModule) },
  { path: 'privacy-policy', loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyModule) },
  { path: 'terms-conditions', loadChildren: () => import('./pages/terms-condition/terms-condition.module').then(m => m.TermsConditionModule) },
  { path: 'home-buying-guide', loadChildren: () =>import('./pages/buying-guide/buying-guide/buying-guide.module').then(m => m.BuyingGuideModule)},
  // { path: 'get-start', canActivate: [AuthGuard], component: GetStartComponent },
  // {path:'city-info',component:CityUpdateComponent},
  { path: 'city-news-update', loadChildren: () =>import('./pages/city-update/city-update.module').then(m => m.CityUpdateModule)},

  // Blog-related routes
  { path: 'blog', loadChildren: () => import('./pages/blog/blog.module').then(m => m.BlogModule) },
  { path: 'blog/details/:id', loadChildren: () => import('./pages/old-blog-details/old-blog-details.module').then(m => m.OldBlogDetailsModule) },
  { path: 'property/details/:id', loadChildren: () => import('./pages/old-property-details/old-property-details.module').then(m => m.OldPropertyDetailsModule) },
  { path: 'account', loadChildren: () => import('./pages/account/account.module').then(m => m.AccountModule) },
  { path: 'auction', loadChildren: () => import('./pages/auction/auction.module').then(m => m.AuctionModule) },
  { path: 'sell', loadChildren: () => import('./pages/sell/sell.module').then(m => m.SellModule) },
  { path: 'container', loadChildren: () => import('./pages/recently-search-view-saved/recently-search-view-saved.module').then(m => m.RecentlySearchViewSavedModule) },
  { path: 'bid', canActivate: [AuthGuard], loadChildren: () => import('./pages/bid/bid.module').then(m => m.BidModule) },
  { path: 'profile', canActivate: [AuthGuard], loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfileModule) },
  { path: 'news-and-articles', loadChildren: () => import('./pages/news-article/news-article.module').then(m => m.NewsArticleModule) },
  {path: 'glossary',loadChildren: () => import('./pages/glossary/glossary.module').then(m => m.GlossaryModule)},
  {path: 'notifications',loadChildren: () => import('./pages/notification/notification-details/notification-details.module').then(m => m.NotificationDetailsModule)},

  // {
  //   path: 'city-page',
  //   loadChildren: () => import('./pages/city-page/city-page.module').then(m => m.CityPageModule)
  // },
  {path: 'knowledge-hub', loadChildren: () => import('./pages/knowledge-hub/knowledge-hub.module').then(m => m.KnowledgeHubModule) },
  { path: ':formattedSentence', loadChildren: () => import('./pages/property/property.module').then(m => m.PropertyModule) },
   
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
